import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const B = "/admin/studio";

export const studioApi = {
  status: () => api.get(`${B}/status`),
  match: (body) => api.post(`${B}/match`, body),
  start: (body) => api.post(`${B}/start`, body),
  uploadLogo: (oid, revision, file) => {
    const fd = new FormData();
    fd.append("revision", revision);
    fd.append("file", file);
    return api.post(`/admin/website-production/orders/${oid}/logo`, fd);
  },
  orders: () => api.get(`${B}/orders`),
  order: (id) => api.get(`${B}/orders/${id}`),
  research: (id) => api.get(`${B}/orders/${id}/research`),
  scanSource: (id) => api.post(`${B}/orders/${id}/research/scan`),
  addReference: (id, revision, url) => api.post(`${B}/orders/${id}/research/references`, { revision, url }),
  removeReference: (id, refId, revision) => api.delete(`${B}/orders/${id}/research/references/${refId}`, { params: { revision } }),
  saveHypothesis: (id, revision, items) => api.put(`${B}/orders/${id}/research/hypothesis`, { revision, items }),
  getProfile: (id) => api.get(`${B}/orders/${id}/profile`),
  saveProfile: (id, body) => api.put(`${B}/orders/${id}/profile`, body),
  setPhase: (id, revision, phase) => api.put(`${B}/orders/${id}/phase`, { revision, phase }),
  listMessages: (id) => api.get(`${B}/orders/${id}/messages`),
  createMessage: (id, body) => api.post(`${B}/orders/${id}/messages`, body),
  updateMessage: (id, mid, body) => api.put(`${B}/orders/${id}/messages/${mid}`, body),
  deleteMessage: (id, mid, revision) => api.delete(`${B}/orders/${id}/messages/${mid}`, { params: { revision } }),
  leitstand: () => api.get(`${B}/leitstand`),
};

export const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}${Math.random()}`).replace(/[^A-Za-z0-9_-]/g, "");

const DRAFT_KEY = "studio_start_draft_v1";
export const loadStartDraft = () => {
  try { const raw = localStorage.getItem(DRAFT_KEY); return raw ? JSON.parse(raw) : null; } catch { return null; }
};
export const saveStartDraft = (d) => { try { localStorage.setItem(DRAFT_KEY, JSON.stringify(d)); } catch { /* ignore */ } };
export const clearStartDraft = () => { try { localStorage.removeItem(DRAFT_KEY); } catch { /* ignore */ } };

export const errText = (t, e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return t(d) !== d ? t(d) : d;
  return t(fallback);
};

export function useStudio() {
  const { t, lang } = useI18n();
  return {
    t, lang,
    err: (e, fallback) => errText(t, e, fallback),
    fmtDate: (iso) => (iso ? new Date(iso).toLocaleString("de-CH", { dateStyle: "short", timeStyle: "short" }) : "–"),
  };
}
